import { DATA_CONNECTOR_OPEN_EXTERNAL_DB_SETTING_MODAL } from './constants';

export function openExternalDbSettingModal(args) {
  return {
    type: DATA_CONNECTOR_OPEN_EXTERNAL_DB_SETTING_MODAL,
    data: args,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_OPEN_EXTERNAL_DB_SETTING_MODAL:
      return {
        ...state,
        isOpenExternalDbSettingModal: !state.isOpenExternalDbSettingModal,
        selectedExternalDb: action.data,
      };

    default:
      return state;
  }
}
